import Home from "./home.jsx"

export default Home